import React, { Component, Fragment } from "react";
import { Route, Redirect, Switch } from "react-router-dom";

import auth from "./services/authService";
import NavBar from "./components/navBar";
import SideBar from "./components/sideBar";
import Logout from "./components/logout";
import LoginForm from "./components/loginForm";
import NotFound from "./components/notFound";
import Footer from "./components/footer";
import ScrollToTop from "./components/scrollToTop";
import ProtectedRoute from "./components/common/protectedRoute";
import DashBoard from "./components/dashboard";
import Users from "./components/users";
//import CardTypes from './components/cardTypes';
//import CardTypeForm from './components/cardTypeForm';
//import CardCurrencies from './components/cardCurrencies';
//import CardCurrencyForm from './components/cardCurrencyForm';
//import CardRanges from './components/cardRanges';
//import CardRangeForm from './components/cardRangeForm';
//import CardReceipts from './components/cardReceipts';
//import CardReceiptForm from './components/cardReceiptForm';
import GTrades from "./components/gtrades";
import GTradeInfo from "./components/gtradeInfo";
import BTrades from "./components/btrades";
import BTradeInfo from "./components/btradeInfo";
import Debits from "./components/debits";
import Credits from "./components/credits";
import BitcoinWalletTypes from "./components/bwalletTypes";
import BitcoinWalletTypeForm from "./components/bwalletTypeForm";
import TradeTypes from "./components/tradeTypes";
import TradeTypeForm from "./components/tradeTypeForm";
import CreditForm from "./components/creditForm";

import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { ToastContainer } from "react-toastify";
//import Cards from './components/cards';
//import CardForm from './components/cardForm';
//import CardCountryForm from './components/cardCountryForm';
//import CardCountries from './components/cardCountries';
import CardCodes from "./components/cardCodes";
import CardCodeForm from "./components/cardCodeForm";
import Admin from "./components/admin";
import TradeResponseForm from "./components/tradeResponseForm";
import TradeResponses from "./components/tradeResponses";
import ClosedTradeForm from "./components/closedTradeForm";
import ClosedTrades from "./components/closedTrades";
import PasswordResetForm from "./components/passwordResetForm";
import BuyBitcoins from "./components/buyBitcoins";
import SettingForm from "./components/settingForm";
import Settings from "./components/settings";
import TwofaForm from "./components/twofaForm";
import Notification from "./components/notification";
import ClosedTradeInfo from "./components/closedTradeinfo";
import BtcRates from "./components/btcrates";
import Feedbacks from "./components/feedbacks";
import UserInfo from "./components/userInfo";

class App extends Component {
  state = {
    user: {},
  };

  componentDidMount() {
    const user = auth.getCurrentUser();
    this.setState({ user });
  }

  render() {
    const { user } = this.state;
    return (
      <Fragment>
        <ToastContainer />
        <div id="wrapper">
          {user && <SideBar user={user} />}
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              {user && <NavBar user={user} />}
              <div className="container-fluid">
                <Switch>
                  <Route path="/login" component={LoginForm} />
                  <Route path="/twofa" component={TwofaForm} />
                  <Route path="/logout" component={Logout} />
                  <Route
                    path="/password-reset/:id"
                    render={(props) => <PasswordResetForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/closed-trades/edit/:id"
                    render={(props) => <ClosedTradeForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/credits/edit/:id"
                    render={(props) => <CreditForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/settings/edit/:id"
                    render={(props) => <SettingForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/bwallet-types/edit/:id"
                    render={(props) => <BitcoinWalletTypeForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/trade-types/edit/:id"
                    render={(props) => <TradeTypeForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/trade-responses/edit/:id"
                    render={(props) => <TradeResponseForm {...props} />}
                  />
                  {/* <ProtectedRoute
                    path="/cards/edit/:id"
                    render={(props) => <CardForm {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-countries/edit/:id"
                    render={(props) => <CardCountryForm {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-types/edit/:id"
                    render={(props) => <CardTypeForm {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-currencies/edit/:id"
                    render={(props) => <CardCurrencyForm {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-ranges/edit/:id"
                    render={(props) => <CardRangeForm {...props} />}
                  /> */}
                  <ProtectedRoute
                    path="/card-codes/edit/:id"
                    render={(props) => <CardCodeForm {...props} />}
                  />
                  {/* <ProtectedRoute
                    path="/card-receipts/edit/:id"
                    render={(props) => <CardReceiptForm {...props} />}
                  /> */}
                  <ProtectedRoute
                    path="/gcards/show/:id"
                    render={(props) => <GTradeInfo {...props} />}
                  />
                  <ProtectedRoute
                    path="/bitcoins/show/:id"
                    render={(props) => <BTradeInfo {...props} />}
                  />
                  <ProtectedRoute
                    path="/closed-trades/:id"
                    render={(props) => <ClosedTradeForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/closed_trades/show/:id"
                    render={(props) => <ClosedTradeInfo {...props} />}
                  />
                  <ProtectedRoute
                    path="/credits/:id"
                    render={(props) => <CreditForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/settings/:id"
                    render={(props) => <SettingForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/bwallet-types/:id"
                    render={(props) => <BitcoinWalletTypeForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/trade-types/:id"
                    render={(props) => <TradeTypeForm {...props} />}
                  />
                  <ProtectedRoute
                    path="/trade-responses/:id"
                    render={(props) => <TradeResponseForm {...props} />}
                  />
                  {/* <ProtectedRoute
                    path="/cards/:id"
                    render={(props) => <CardForm {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-countries/:id"
                    render={(props) => <CardCountryForm {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-types/:id"
                    render={(props) => <CardTypeForm {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-currencies/:id"
                    render={(props) => <CardCurrencyForm {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-ranges/:id"
                    render={(props) => <CardRangeForm {...props} />}
                  /> */}
                  <ProtectedRoute
                    path="/card-codes/:id"
                    render={(props) => <CardCodeForm {...props} />}
                  />
                  {/* <ProtectedRoute
                    path="/card-receipts/:id"
                    render={(props) => <CardReceiptForm {...props} />}
                  /> */}
                  <ProtectedRoute
                    path="/users"
                    render={(props) => <Users {...props} />}
                  />
                  <ProtectedRoute
                    path="/user/:id"
                    render={(props) => <UserInfo {...props} />}
                  />
                  <ProtectedRoute
                    path="/admin"
                    render={(props) => <Admin {...props} />}
                  />
                  <ProtectedRoute
                    path="/notification"
                    render={(props) => <Notification {...props} />}
                  />
                  <ProtectedRoute
                    path="/btcrates"
                    render={(props) => <BtcRates {...props} />}
                  />
                  <ProtectedRoute
                    path="/gcards"
                    render={(props) => <GTrades {...props} />}
                  />
                  <ProtectedRoute
                    path="/bitcoins"
                    render={(props) => <BTrades {...props} />}
                  />
                  <ProtectedRoute
                    path="/debits"
                    render={(props) => <Debits {...props} />}
                  />
                  <ProtectedRoute
                    path="/buy-bitcoins"
                    render={(props) => <BuyBitcoins {...props} />}
                  />
                  <ProtectedRoute
                    path="/closed-trades"
                    render={(props) => <ClosedTrades {...props} />}
                  />
                  <ProtectedRoute
                    path="/credits"
                    render={(props) => <Credits {...props} />}
                  />
                  <ProtectedRoute
                    path="/settings"
                    render={(props) => <Settings {...props} />}
                  />
                  <ProtectedRoute
                    path="/bwallet-types"
                    render={(props) => <BitcoinWalletTypes {...props} />}
                  />
                  <ProtectedRoute
                    path="/trade-types"
                    render={(props) => <TradeTypes {...props} />}
                  />
                  <ProtectedRoute
                    path="/trade-responses"
                    render={(props) => <TradeResponses {...props} />}
                  />
                  {/* <ProtectedRoute
                    path="/cards"
                    render={(props) => <Cards {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-countries"
                    render={(props) => <CardCountries {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-types"
                    render={(props) => <CardTypes {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-currencies"
                    render={(props) => <CardCurrencies {...props} />}
                  /> */}
                  {/* <ProtectedRoute
                    path="/card-ranges"
                    render={(props) => <CardRanges {...props} />}
                  /> */}
                  <ProtectedRoute
                    path="/card-codes"
                    render={(props) => <CardCodes {...props} />}
                  />
                  <ProtectedRoute
                    path="/feedbacks"
                    render={(props) => <Feedbacks {...props} />}
                  />
                  {/* <ProtectedRoute
                    path="/card-receipts"
                    render={(props) => <CardReceipts {...props} />}
                  /> */}
                  <Route path="/not-found" component={NotFound} />
                  <ProtectedRoute path="/" component={DashBoard} />
                  <Redirect exact from="/" to="/" />
                  <Redirect exact to="/not-found" />
                </Switch>
              </div>
            </div>
            {user && <Footer />}
          </div>
        </div>
        <ScrollToTop />
      </Fragment>
    );
  }
}

export default App;
